import { CONSTANTS } from './../constants/constants';
import { Loader } from '@googlemaps/js-api-loader';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  private static marker: google.maps.MarkerLibrary;
  private static maps: google.maps.MapsLibrary;
  private static places: google.maps.PlacesLibrary;
  private static geocoder: google.maps.GeocodingLibrary;
  private static loader: Loader;

  private static async getLoader(): Promise<Loader> {
    if (!GoogleService.loader) {
      this.loader = new Loader({
        apiKey: CONSTANTS.GOOGLE_API_KEY,
        version: 'weekly',
        libraries: ['places'],
      });
    }

    return Promise.resolve(this.loader);
  }

  static async getMarker(): Promise<google.maps.MarkerLibrary> {
    if (!GoogleService.marker) {
      const loader = await this.getLoader();
      GoogleService.marker = (await loader.importLibrary(
        'marker'
      )) as google.maps.MarkerLibrary;
    }

    return Promise.resolve(GoogleService.marker);
  }

  static async getMaps(): Promise<google.maps.MapsLibrary> {
    if (!GoogleService.maps) {
      const loader = await this.getLoader();
      GoogleService.maps = (await loader.importLibrary(
        'maps'
      )) as google.maps.MapsLibrary;
    }

    return Promise.resolve(GoogleService.maps);
  }

  static async getPlaces(): Promise<google.maps.PlacesLibrary> {
    if (!GoogleService.places) {
      const loader = await this.getLoader();
      GoogleService.places = (await loader.importLibrary(
        'places'
      )) as google.maps.PlacesLibrary;
    }

    return Promise.resolve(GoogleService.places);
  }

  static async getGeocoder(): Promise<google.maps.GeocodingLibrary> {
    if (!GoogleService.geocoder) {
      const loader = await this.getLoader();
      GoogleService.geocoder = (await loader.importLibrary(
        'geocoding'
      )) as google.maps.GeocodingLibrary;
    }

    return Promise.resolve(GoogleService.geocoder);
  }
}
